import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ButtonComponent } from "../../../components/forms/button/button.component";
import { TableMarches } from '../../../data/schemas/table.schema';
import { UiTable } from '../../../components/ui/table/table.component';
import { ActiviteForReportService } from '../../../services/activiteForReportService';
import { TypeActiviteService } from '../../../services/typeactivites/typeactivite.service';
import { ReportService } from '../../../services/report.service';
import { TypeInterventionService } from '../../../services/typeintervention/typeintervention.service';
// CookiesService replaced by AppService usage
import { TypeActiviteResponse } from '../../../data/http/responses/typeactivite.response';
import { ActivtieResponse } from '../../../data/http/responses/activite.response';
import { TypeInterventionResponse } from '../../../data/http/responses/typeintervention.response';
import { IActiviteMarche } from '../model/IActiviteMarche';
import { AppService } from '../../../core/app.service';
import { ActiviteService } from '../../../services/activite/activite.service';
import { MatIcon } from "@angular/material/icon";
import { OngletlayoutComponent } from "../../../components/layouts/ongletlayout/ongletlayout.component";
import { routeAlias } from '../../../../routesalias';
import { RouterOutlet } from '@angular/router';
import { ModePassationMarcheService } from '../../../services/modepassation.service';
import { TypeModePassationMarcheService } from '../../../services/typepassation.service';
import { ModePassationMarcheRes } from '../../../data/http/responses/modepassationmarche.res';
import { NgIf } from '@angular/common';
import { UiButtonComponent } from '../../../components/button/button.component';


@Component({
  selector: 'app-marches',
  imports: [MatIcon, OngletlayoutComponent, RouterOutlet, NgIf,UiButtonComponent],
  templateUrl: './marches.component.html',
  styleUrl: './marches.component.css',

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarchesPage {
  public marchesColumns = TableMarches
  public marches: ActivtieResponse[] = [];

  tableLinkForMarches = [
    {
      text: "Expression de besoin",
      link: routeAlias.marchees.expression_besoin.home,
    },
    {
      text: "Marchés",
      link: routeAlias.marchees.marches.home,
    },
  ]

  constructor(
    private structureProgrammatiqueService: ActiviteForReportService,
    private reportService: ReportService,
    private AppService: AppService,
    private modePassationMarcheService: ModePassationMarcheService,
    private typeModePassationMarcheService: TypeModePassationMarcheService,
    private activiteService: ActiviteService
  ) { }
  public data: any[] = []
  public structures: ActivtieResponse[] = [];
  public activites: ActivtieResponse[] = [];
  public typeInterventionData: TypeInterventionResponse[] = [];
  ngOnInit(): void {
    this.loadStructures();

    this.loadActivities()
    //console.log(this.structures)
  }

  hasAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    // Utilise le même service que la sidebar
    if (this.AppService['authService'] && typeof this.AppService['authService'].hasAnyRole === 'function') {
      const result = this.AppService['authService'].hasAnyRole(roles);
      try {
        //console.debug('ExpressionBesoin.hasAccess check', { required: roles, userRoles: this.AppService['authService'].getUserRoles(), allowed: result });
      } catch (e) { }
      return result;
    }
    return false;
  }

  loadActivities(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response) => {
        const allActivities = response.data as ActivtieResponse[];

        // Filtrer les activités pour ne garder que celles avec MODEEXECUTION: PMP
        this.marches = allActivities.filter(activity =>
          activity.caracteristiques?.some(caracteristique =>
            (caracteristique.code === 'MODEEXECUTION' || caracteristique.code === 'MODE_EXECUTION') && caracteristique.valeur === 'PMP'
          )
        );

        //console.log("Activités PMP chargées et filtrées:", this.marches);
      },
      error: (error) => {
        console.error("Erreur lors du chargement des activités", error);
      }
    })
  }

  loadStructures(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        this.activites = response.data;
        //console.log("Activites : " + this.activites)

        this.activites.forEach((activite) => {
          if (activite.typeActivite === "PROGRAMME" || activite.typeActivite === "PROGRAMMES") {
            this.structures.push(activite);
          }
        });

        //console.log("Structure : " + this.structures)
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }





  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPpmXlsx() {
    this.telechargerRapportPpm('xlsx')
  }

  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPpm(format = 'pdf') {

    //this.loadStructures();
    //console.log("Strucutres : " + this.structures)

    try {
      this.data = []
      let i: number = 0;

      this.structures.forEach((programme) => {
        programme.taches?.forEach((ob) => {
          ob.taches?.forEach((resultat) => {
            resultat.taches?.forEach((act) => {
              i++;
              this.toData(i, act);
            })
          });
        });
      });


      //console.log(this.data)
      const parameters = {
        annee: 2026,
        date_diffusion: Date.UTC(2026, 2, 7),
        date_validation: Date.UTC(2026, 1, 30),
        version: 1,
      }
      if (this.data.length === 0) return;
      const blob = this.reportService.generatePpmReport(format, this.data, parameters).subscribe({
        next: (blob: Blob) => {

          if (format === 'pdf') {
            this.reportService.openOrDownloadReport(blob, `ppm.pdf`)
          } else {
            this.reportService.downloadReport(blob, `ppm.${format}`)
          }
        },
        error: (err: any) => console.error('Erreur téléchargement :', err)
      });

    } catch (error) {
      console.error('Erreur lors du téléchargement du rapport:', error)
    }
  }

  getMode(id: number | string): ModePassationMarcheRes | null {
    let modePassationMarches: ModePassationMarcheRes | null = null;
    this.modePassationMarcheService.getById(id).subscribe({
      next: (response: any) => {
        modePassationMarches = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });

    return modePassationMarches;
  }


  toData(ref: number, act: ActivtieResponse) {

    //console.log(" activite : " + act)

    /* let ref_num :    string = '';
    let description :    string = '';
    let direction_responsable :    string = '';
    let delais_execution:    number = 0;
    let type_marche :    string = '';
    let mode_passation :    string = '';
    let montant_estimatif :   number = 0;
    let source_financement :    string = '';
    let ligne_imput_budge :    string = '';
    let autorisation_engage :    string = '';
    let date_reception :    Date | null = null;
    let date_limite_montage :    Date | null = null;
    let date_limite_auto_lancement :    Date | null = null;
    let date_limite_publication :    Date | null = null;
    let date_ouverture_manif :    Date | null = null;
    let date_limite_evaluation :    Date | null = null;
    let date_limite_delais_attente :    Date | null = null;
    let date_limite_publication_dp :    Date | null = null;
    let date_ouverture_propos :    string = '';
    let date_limite_evaluation_proposition :    Date | null = null;
    let date_reception_avis :    Date | null = null;
    let date_notif_result :    Date | null = null;
    let date_limite_delais :    Date | null = null;
    let date_ouverture_offres :    Date | null = null;
    let date_limite_eva_propos :    Date | null = null;
    let date_recep_avis :    Date | null = null;
    let date_notif_res :    Date | null = null;
    let date_limite_delais_attente_res :    Date | null = null;
    let date_fin_negoc :    Date | null = null;
    let date_compte_rendu :    Date | null = null;
    let date_limite_elaboration :    Date | null = null;
    let date_exam_jurid :    Date | null = null;
    let date_limite_signature :    Date | null = null;
    let date_limite_visa_cjc :    Date | null = null;
    let date_limite_visa_dm :    Date | null = null;
    let date_limite_visa_dcgis :    Date | null = null;
    let date_limite_visa_dga :    Date | null = null;
    let date_limite_sign_contract :    Date | null = null;
    let date_limite_notif_contrat :    Date | null = null;
    let date_limite_mise_exec :    Date | null = null;
    let date_preventionnelle :    Date | null = null;
    let date_limite_notif_result :    Date | null = null;
  
    
              act.caracteristiques?.forEach((caract) => {
              if("STRUCTURERESPONSABLE".toUpperCase() === caract.code){
        direction_responsable = caract.valeur;
        //console.log("code : " + caract.code + " valeur : "+ caract.valeur); 
                }else if("MONTANTESTIMATIF".toUpperCase()  === caract.code){
        montant_estimatif = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : "+ caract.valeur); 
                }else if( "IMPUTATIONBUDGETAIRE".toUpperCase()  === caract.code){
        ligne_imput_budge =  caract.valeur;
        //console.log("code : " + caract.code + " valeur : "+ caract.valeur); 
                }
              });
         */
    // variables initiales (comme tu avais)
    let ref_num: string = '';
    let description: string = '';
    let direction_responsable: string = '';
    let delais_execution: number = 0;
    let type_marche: string = '';
    let mode_passation: string = '';
    let montant_estimatif: number = 0;
    let source_financement: string = '';
    let ligne_imput_budge: string = '';
    let autorisation_engage: string = '';
    let date_reception: Date | null = null;
    let date_limite_montage: Date | null = null;
    let date_limite_auto_lancement: Date | null = null;
    let date_limite_publication: Date | null = null;
    let date_ouverture_manif: Date | null = null;
    let date_limite_evaluation: Date | null = null;
    let date_limite_delais_attente: Date | null = null;
    let date_limite_publication_dp: Date | null = null;
    let date_ouverture_propos: string = '';
    let date_limite_evaluation_proposition: Date | null = null;
    let date_reception_avis: Date | null = null;
    let date_notif_result: Date | null = null;
    let date_limite_delais: Date | null = null;
    let date_ouverture_offres: Date | null = null;
    let date_limite_eva_propos: Date | null = null;
    let date_recep_avis: Date | null = null;
    let date_notif_res: Date | null = null;
    let date_limite_delais_attente_res: Date | null = null;
    let date_fin_negoc: Date | null = null;
    let date_compte_rendu: Date | null = null;
    let date_limite_elaboration: Date | null = null;
    let date_exam_jurid: Date | null = null;
    let date_limite_signature: Date | null = null;
    let date_limite_visa_cjc: Date | null = null;
    let date_limite_visa_dm: Date | null = null;
    let date_limite_visa_dcgis: Date | null = null;
    let date_limite_visa_dga: Date | null = null;
    let date_limite_sign_contract: Date | null = null;
    let date_limite_notif_contrat: Date | null = null;
    let date_limite_mise_exec: Date | null = null;
    let date_preventionnelle: Date | null = null;
    let date_limite_notif_result: Date | null = null;

    let modePassation: ModePassationMarcheRes | null = null;
    let modePassationCode: string = '';

    // Fonctions utilitaires
    function toNumberSafe(v: any, defaultValue = 0): number {
      if (v === null || v === undefined || v === '') return defaultValue;
      const n = Number(v);
      return isNaN(n) ? defaultValue : n;
    }

    function toDateSafe(v: any): Date | null {
      if (v === null || v === undefined || v === '') return null;
      // Si c'est déjà une Date
      if (v instanceof Date) {
        return isNaN(v.getTime()) ? null : v;
      }
      // Si c'est un nombre (timestamp)
      if (typeof v === 'number') {
        const d = new Date(v);
        return isNaN(d.getTime()) ? null : d;
      }
      // Si c'est une chaîne : essayer Number puis parse ISO
      const n = Number(v);
      if (!isNaN(n)) {
        const d = new Date(n);
        if (!isNaN(d.getTime())) return d;
      }
      const d2 = new Date(String(v));
      return isNaN(d2.getTime()) ? null : d2;
    }

    // Mapping : parcours les caractéristiques et affecte les variables
    act.caracteristiques?.forEach((caract) => {
      if ("STRUCTURERESPONSABLE".toUpperCase() === caract.code || "STRUCTURE_RESPONSABLE".toUpperCase() === caract.code) {
        direction_responsable = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANT_ESTIMATIF".toUpperCase() === caract.code || "MONTANTESTIMATIF".toUpperCase() === caract.code) {
        montant_estimatif = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("IMPUTATIONBUDGETAIRE".toUpperCase() === caract.code || "IMPUTATION_BUDGETAIRE".toUpperCase() === caract.code) {
        ligne_imput_budge = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MODEPASSATIONMARCHE".toUpperCase() === caract.code) {
        modePassationCode = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
    });

    modePassation = this.getMode(modePassationCode);

    //console.log("modePasationCode : " + modePassationCode + " modePassation : " + modePassation);
    if (modePassation?.details) {
      modePassation?.details?.forEach(caract => {
        const code = (caract.code || '').toString().toUpperCase();
        const val = caract.valeur;

        switch (code) {

          case "MODEPASSATIONMARCHE":
            mode_passation = val;
            break;

          case "DELAIPUBLICATION":

            break;

          case "SEUIL":
            break;

          case "MONTAGE":
            break;

          case "LANCEMENT":
            break;

          case "OUVERTURE":
            break;

          case "EVALUATION":
            break;

          case "NEGOCIATIONGREGRE":
            break;

          case "ORGANECONTROLE":
            break;

          case "VERIFICATIONDISPONIBILITECREDITS":
            break;

          case "NOTIFICATIONRESULTATS":
            break;

          case "DELAIATTENTEELABORATIONCONTRAT":
            break;

          case "EXAMENJURIDIQUEPROJETCONTRATCJC":
            break;

          case "SIGNATURECONTRATTITULAIRE":
            break;

          case "VISACONTRATJURISTE":
            break;

          case "VISACONTRATDM":
            break;

          case "VISACONTRATDFC":
            break;

          case "VISACONTRATDCGIS":
            break;

          case "VISACONTRATDGA":
            break;

          case "SIGNATURECONTRATDG":
            break;

          case "NOTIFICATIONCONTRATTITULAIRESC":
            break;

          case "DELAIDELIVRANCEOS":
            break;

        }
        //console.log("code : " + code + " valeur : " + val);
      });
    } else {

    }

    //console.log(" type : " + act.typeActivite)
    ref_num = `${ref}_${type_marche}_${direction_responsable}`;
    const activite: IActiviteMarche = {
      type: act.typeActivite,
      num: ref,
      ref_num: ref_num,
      objet: act.titre,
      description: description,
      direction_responsable: direction_responsable,
      delais_execution: delais_execution,
      type_marche: modePassation!.type,
      mode_passation: mode_passation,
      montant_estimatif: montant_estimatif,
      source_financement: source_financement,
      ligne_imput_budge: ligne_imput_budge,
      autorisation_engage: autorisation_engage,
      date_reception: date_reception,
      date_limite_montage: date_limite_montage,
      date_limite_auto_lancement: date_limite_auto_lancement,
      date_limite_publication: date_limite_publication,
      date_ouverture_manif: date_ouverture_manif,
      date_limite_evaluation: date_limite_evaluation,
      date_limite_delais_attente: date_limite_delais_attente,
      date_limite_publication_dp: date_limite_publication_dp,
      date_ouverture_propos: date_ouverture_propos,
      date_limite_evaluation_proposition: date_limite_evaluation_proposition,
      date_reception_avis: date_reception_avis,
      date_notif_result: date_notif_result,
      date_limite_delais: date_limite_delais,
      date_ouverture_offres: date_ouverture_offres,
      date_limite_eva_propos: date_limite_eva_propos,
      date_recep_avis: date_recep_avis,
      date_notif_res: date_notif_res,
      date_limite_delais_attente_res: date_limite_delais_attente_res,
      date_fin_negoc: date_fin_negoc,
      date_compte_rendu: date_compte_rendu,
      date_limite_elaboration: date_limite_elaboration,
      date_exam_jurid: date_exam_jurid,
      date_limite_signature: date_limite_signature,
      date_limite_visa_cjc: date_limite_visa_cjc,
      date_limite_visa_dm: date_limite_visa_dm,
      date_limite_visa_dcgis: date_limite_visa_dcgis,
      date_limite_visa_dga: date_limite_visa_dga,
      date_limite_sign_contract: date_limite_sign_contract,
      date_limite_notif_contrat: date_limite_notif_contrat,
      date_limite_mise_exec: date_limite_mise_exec,
      date_preventionnelle: date_preventionnelle,
      date_limite_notif_result: date_limite_notif_result
    };

    this.data.push({ ...activite });
  }


}
